//Operations

export enum BuyOrderOperationEnum {
  AddBuyOrderProductVariant = "add-buy-order-product-variant",
  AddBuyOrderProduct = "add-buy-order-product",
  DeleteBuyOrderProduct = "delete-buy-order-product",
  PlaceBuyOrder = "pleace-buy-order",
}
